module.exports = __webpack_public_path__ + "img/work4.751fbae4.png";